import styles from '../styles/Archives.module.css';

const BigTitle = ({text}) => {
    return <h1 className={styles.bigTitle}>{text}</h1>
};

export default BigTitle;